import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { submitInquiryApi } from '@/lib/about/inquiryApi';
import type { InquiryFormTypes } from '@/lib/about/inquiryApiTypes';
import { useDeviceStore } from '@/store/about/deviceStore';
import { useInquiryStore } from '@/store/about/useInquiryStore';
export const useInquiryForm = close => {
  const $ = _c(20);
  const {
    deviceType
  } = useDeviceStore();
  const {
    setComplete
  } = useInquiryStore();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [activeItems, setActiveItems] = useState(t0);
  const [keyword, setKeyword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      tel: "",
      preOpen: "N",
      agencyNm: null,
      brokerNm: null,
      brokerPosition: null,
      roadAddr: null,
      openRegNo: null,
      isPersonalTrm: "N",
      isAdTrm: "N",
      agencyTel: null,
      marketerId: null,
      roadDetailAddr: null,
      nCounselType: 1
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [formData, setFormData] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      const {
        name,
        type,
        checked,
        value
      } = e.target;
      if (type === "checkbox") {
        setFormData(prev => ({
          ...prev,
          [name]: checked ? "Y" : "N"
        }));
        if (name === "preOpen" && checked === true) {
          setKeyword("");
          setFormData(_temp);
        }
      } else {
        setFormData(prev_1 => ({
          ...prev_1,
          [name]: type === "checkbox" ? checked : value
        }));
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleChangeForm = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      const {
        value: value_0
      } = e_0.target;
      const onlyNumber = value_0.replace(/[^0-9]/g, "");
      const phoneRegex = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;
      setPhoneNumber(onlyNumber);
      if (phoneRegex.test(onlyNumber) && onlyNumber.length === 11) {
        setFormData(prev_2 => ({
          ...prev_2,
          tel: onlyNumber
        }));
      } else {
        setFormData(_temp2);
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const phoneValidation = t3;
  const toggleItem = _temp3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = id_0 => {
      setActiveItems(prev_4 => toggleItem(prev_4, id_0));
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const toggleActive = t4;
  const isButtonDisabled = formData.preOpen === "Y" ? !(formData.tel.length > 0 && formData.isPersonalTrm === "Y") : !(formData.agencyNm !== null && formData.tel.length > 0 && formData.isPersonalTrm === "Y");
  let t5;
  if ($[5] !== close || $[6] !== deviceType || $[7] !== formData.tel || $[8] !== setComplete) {
    t5 = {
      mutationFn: _temp4,
      onSuccess: () => {
        if (close) {
          close();
        }
        if (deviceType === "mobile") {
          setComplete(`${formData.tel.slice(0, 3)}-${formData.tel.slice(3, 7)}-${formData.tel.slice(7)}`);
          document.getElementById("inquiry_complete")?.scrollIntoView({
            behavior: "smooth"
          });
        }
      },
      onError: _temp5
    };
    $[5] = close;
    $[6] = deviceType;
    $[7] = formData.tel;
    $[8] = setComplete;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const inquiryMutation = useMutation(t5);
  let t6;
  if ($[10] !== formData || $[11] !== inquiryMutation) {
    t6 = e_1 => {
      e_1.preventDefault();
      inquiryMutation.mutate(formData);
    };
    $[10] = formData;
    $[11] = inquiryMutation;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleSubmitInquiry = t6;
  let t7;
  if ($[13] !== activeItems || $[14] !== formData || $[15] !== handleSubmitInquiry || $[16] !== isButtonDisabled || $[17] !== keyword || $[18] !== phoneNumber) {
    t7 = {
      activeItems,
      keyword,
      setKeyword,
      phoneNumber,
      formData,
      setFormData,
      handleChangeForm,
      phoneValidation,
      toggleActive,
      isButtonDisabled,
      handleSubmitInquiry
    };
    $[13] = activeItems;
    $[14] = formData;
    $[15] = handleSubmitInquiry;
    $[16] = isButtonDisabled;
    $[17] = keyword;
    $[18] = phoneNumber;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
function _temp(prev_0) {
  return {
    ...prev_0,
    agencyNm: null,
    brokerNm: null,
    brokerPosition: null,
    roadAddr: null,
    openRegNo: null
  };
}
function _temp2(prev_3) {
  return {
    ...prev_3,
    tel: ""
  };
}
function _temp3(items, id) {
  if (items.includes(id)) {
    return items.filter(item => item !== id);
  }
  return [...items, id];
}
function _temp4(data) {
  return submitInquiryApi(data);
}
function _temp5() {
  alert("\uCC98\uB9AC\uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uC600\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694");
}